import styled from "styled-components";

import { Button } from "@design-system-coopeuch/web";

export const StyledWrapperCards = styled.div`
  /* TODO: Estilos que se repiten en otro wrapper, ver si se mueven a un style global */
  display: grid;
  grid-row-gap: 16px;
  @media screen and (min-width: 768px) {
    grid-row-gap: 32px;
  }

  && .CardBase--shaded {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
  }
  && .CardBase_content--no-padding > div {
    padding-right: 16px;
    padding-left: 16px;
    @media screen and (min-width: 768px) {
      padding-right: 32px;
      padding-left: 32px;
    }
  }
  & .CardBase > header {
    padding: 16px 16px;
    @media screen and (min-width: 768px) {
      padding: 20px 32px;
      align-items: center;
    }
  }
  & .CardBase--titles {
    row-gap: 4px;
  }
  & .CardBase--titles > h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    @media screen and (min-width: 768px) {
      font-size: 24px;
      line-height: 30px;
    }
  }
  & .CardBase--titles > h4 {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase p {
    font-size: 14px;
  }
  & .CardBase .title-content {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  & .CardBase .subtitle-content {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase .text-content {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const StyledButton = styled(Button)`
  justify-content: start;
  padding: 0px;
  & > span {
    font-size: 16px;
  }
  & i {
    font-size: 18px !important;
  }
`;

export const StyledWrapperSms = styled.section`
  & .CardBase header {
    padding: 16px;
    background-color: #dff3fd;
    & h2 {
      font-size: 16px;
      font-weight: 400;
    }
  }
  & .rounded-pill {
    font-size: 20px;
    font-weight: 400;
    @media screen and (min-width: 768px) {
      max-width: 250px;
    }
  }
  /* & .InputCodeSMS {
    @media screen and (min-width: 768px) {
      max-width: 400px;
    }
  } */
`;

export const StyledGridText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .subtitle-cuotas-info {
    font-size: 16px;
    font-weight: bold;
    color: #383638;
    margin-top: -10px;
  }

  .section-info-cuotas {
    list-style-type: disc;
  }

  .section-info-cuotas,
  li {
    color: #383838;
    font-family: Ubuntu;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
    // width: 590px;
    padding: 7px;
    margin-left: 10px;
  }

  .li-4 {
    width: 700px;
  }

  .section-info-cuotas li::marker {
    // color:#007DB7;
    color: #1e1e1e;
    font-size: 1.5em;
  }

  .activa-tu-cuenta {
    // font-family: Ubuntu;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.20000000298023224px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #383838;
  }

  .content {
    flex: 1;
    margin-right: 20px;
  }

  .image-container {
    flex-shrink: 0;
  }

  .image-container img {
    max-width: 100%;
    height: auto;
  }

  .resume-pdf {
    color: #e81e2b;
    margin-left: 1.5%;
    font-weight: 500;
    cursor: pointer;
    // text-decoration: underline;
  }

  .title-resume {
    font-size: 24px;
    color: #383838;
    text-align: center;
    font-family: "Ubuntu";
  }

  @media screen and (max-width: 768px) {
    .resume-pdf  {
      display: block !important;
      margin-top: 10%;
      margin-bottom: 5%;
      margin-left: 6%;
    }
    .flex-container {
      flex-direction: column;
    }
    .section-info-cuotas,
    li {
      width: auto !important;
    }

    .li-4 {
      width: auto !important;
    }

    .image-container {
      display: none;
    }
  }
`;

export const StyledBtn = styled(Button)`
  display: flex !important;
  /* justify-content: center !important; */
  /* align-items: start !important; */
  & > span {
    font-size: 16px;
  }
  & i {
    /* font-size: 18px !important; */
    font-size: ${(props) =>
      props.sizeIcon ? `${props.sizeIcon}px !important` : "24px !important"};
  }
  @media screen and (min-width: 768px) {
    /* justify-content: start !important; */
  }
`;

export const StyledFeedCalMonto = styled.div`
  margin-top: 6%;

  .resumen-aporte-socio {
    border-radius: 5px;
    padding: 13px 24px 13px 32px;
    display: flex;
    justify-content: space-between;
    position: relative;
    min-height: 48px;
    margin-bottom: 0px;
    box-shadow: 0 2px 4px 0 rgba(31, 30, 30, 0.1);
    background-color: #ffffff;
    border: 1px solid #646569;
    height: 96px;
  }
  .title-resumen-aporte {
    color: #001140bf;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.2px;
    margin-top: 12px;
    text-align: initial;
    display: inline-block;
    margin-left: -25px;
  }

  .subtitle-resumen-aporte {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #001140bf;
    display: inline-block;
    margin-left: -25px;
  }

  .content-total-cal {
    background: #e9f5fa;
    border-radius: 5px;
    min-width: 26%;
  }
  .parr-total-content {
    color: #007db7;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    padding-top: 10%;
    padding-left: 14px;
  }
  .span-total-content {
    color: #005d8f;
    font-weight: 700;
    font-style: Bold;
    font-size: 22px;
    line-height: 30px;
    letter-spacing: 0.2px;
    vertical-align: middle;
    padding-left: 10px;
  }
  @media screen and (max-width: 768px) {
    .resumen-aporte-socio {
      display: inline-table;
      margin-top: 7px;
    }
    .title-resumen-aporte {
     // margin-left: 0;
    }
    .subtitle-resumen-aporte {
      padding-top: 15px;
    }

    .content-total-cal {
      margin-top: 15px;
      margin-left: -12px;
    }
    .parr-total-content {
      padding-top: 15px;
      padding-bottom: 10px;
      font-size: 16px;
    }
    .span-total-content  {
      padding-left: 20%;
      font-size: 20px;
    }
    
  }
`;

export const StyledGridFees = styled.div`
  .container-value-cuote {
    // display: inline-flex;
    display: contents;
    margin-left: 35px;
  }

  .content {
    flex: 1;
    margin-right: 20px;
    margin-top: 19px;
  }

  width: 120%;
  display: flex;
  justify-content: center;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  .container-abono-value {
    background: #ecfbe7;
    border-radius: 5px;
    margin-top: 15%;
  }
  .text-value-abono {
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    color: #005d8f;
    // padding: 1rem;
    padding-bottom: 10px;
  }

  .container-cuote-value {
    // background: #001140BF;
    background: #e9f5fa;
    border-radius: 5px;
    margin-top: 15%;
    width: 100%;
  }
  .span-value-abono {
    color: #005d8f;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
  }

  .white-info-abono {
    background: #ffffff;
    padding-top: 9px;
    font-size: 10.2px;
  }
  .span-info-abono {
    color: #007db7;
    font-weight: bold;
    padding: 2.5px;
  }

  .text-inversion {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    margin-left: -20px;
    margin-bottom: 4px;
  }
  .text-value-cuote {
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    color: #005d8f;
    // padding: 1rem;
    padding-bottom: 10px;
  }
  .text-value-cuote-hide {
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    color: #005d8f;
    padding-bottom: 39px;
  }
  .white-info-cuote {
    background: #ffffff;
    padding-top: 9px;
    font-size: 10.2px;
  }
  .span-value-cuote {
    color: #005d8f;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
  }
  .text-center-info-cuote {
    text-align: left;
    width: 170px;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    color: #383838;
    margin-top: 6%;
    margin-left: -7px;
  }

  .span-info-cuote {
    color: #007db7;
    font-weight: bold;
    padding: 2.5px;
  }

  .equals {
    margin-left: -25px;
  }

  .plus-abono {
    // margin-left: -10px;
    margin-top: 50px;
    font-size: 20px;
    font-weight: bold;
    color: #007db7;
  }

  & input[type="text"] {
    text-align: left;
    // width: 120%;
    margin-left: -25px;
  }

  & > div.image-container {
    display: flex;
    justify-content: flex-start;
  }

  & > div.text-description {
    text-align: center;
  }

  & > div:nth-child(3) {
    justify-content: flex-start;
  }

  & > div:nth-child(3) {
    margin-bottom: 12px;
  }

  @media screen and (min-width: 768px) {
    grid-template-columns: 20% 40% 30%; /* Ajusta el ancho de las columnas en pantallas más grandes */
    align-items: center;

    & > div:nth-child(3) {
      margin-bottom: 22px;
    }

    & > div:nth-child(4) {
      display: flex;
      justify-content: flex-end;
    }
  }
  @media screen and (max-width: 768px) {
    width: auto;
    margin-left: 16%;
    div.feeds-grid {
      grid-template-columns: auto 1fr auto;
    }
    .iTxLdV {
      width: auto !important;
    }
    div.image-container {
      display: none;
    }
    .image-container img {
      display: none !important;
    }
    .container-value-cuote {
      display: inline-block;
      margin-left: -20% !important;
      margin-top: -8%;

      .content {
        margin-right: 0px;
        margin-left: 10%;
      }
      .equals {
        margin-left: 45%;
        margin-top: 10%;
      }

      .plus-abono {
        display: inline-block;
        margin-top: 4%;
        margin-left: 45%;
      }
    }
    .span-value-abono {
      padding-top: 12%;
      padding-left: 15px;
    }
    .text-value-abono {
      display: inline-flex;
      font-size: 24px;
      text-align: center;
      font-weight: bold;
      color: #005d8f;
      padding-bottom: 17px;
      margin-top: -3px;
      line-height: 5px;
    }
    .container-cuote-value {
      margin-top: 5%;
    }

    .container-abono-value {
      margin-top: 4%;
    }

    .span-value-total {
      padding-top: 14%;
      font-size: 20px;
      padding-left: 25px;
    }

    .text-value-cuote {
      display: inline-flex;
      padding-bottom: 17px;
      margin-top: -3px;

    }
    .text-value-cuote-hide {
      display: inline-flex;
    }
    .span-cuote-calc {
      font-size: 20px;
      padding-left: 20px;
      padding-top: 25px;
    }
    .span-value-cuote {
      padding-left: 15px;
      padding-top: 25px;
    }
    .white-info-cuote {
      font-size: 12.2px;
      line-height: 1.5;
    }
    .white-info-abono {
      font-size: 12.2px;
      line-height: 1.5;
    }
  }
`;

export const StyledContractContainer = styled.section.attrs(() => ({
  className: "",
}))`
  display: flex;
  flex-direction: column;
  padding: 20px 32px;
  & article {
    flex: 1 1 auto;
    & h6 {
      margin-bottom: 4px;
    }
    & p {
      font-size: 14px;
      line-height: 20px;
      color: #383838;
    }
    & li {
      font-size: 14px;
      line-height: 20px;
      color: #383838;
    }
    & ul,
    ol {
      margin-top: 4px;
      display: grid;
      grid-row-gap: 8px;
      padding-left: 16px;
    }
    & ul {
      list-style: none;
    }
    & ul li::before {
      content: "\\2022";
      /* color: #007dbc; */
      color: #383838;
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1rem;
    }
  }
  & div {
    flex: 0 1 auto;
    display: flex;
    justify-content: center;
  }
  @media screen and (min-width: 768px) {
    flex-direction: row;
    & > div button {
      align-items: flex-start !important;
    }
  }
`;
